<template>
  <div style="height: 450px;">
    <GmapMap :center="center" :zoom="zoom" class="ts-w-full ts-h-full">
      <GmapMarker :position="marker" />
    </GmapMap>
  </div>
</template>

<script>
export default {
  props: ['resource'],
  data() {
    return {
      loading: false,
      zoom: 7,
      center: { lat: 12.565679, lng: 104.990967 },
      marker: { lat: 0, lng: 0 }
    }
  },
  created() {
    if (this.resource.gis_location) {
      this.marker = {
        lat: this.resource.gis_location
          ? this.resource.gis_location[0]['lat']
          : 0,
        lng: this.resource.gis_location
          ? this.resource.gis_location[0]['lng']
          : 0
      }
      this.center = this.marker
      this.zoom = 16
    }
  },
  methods: {
    setPlaceOrLocation(location) {
      this.center = {
        lat: location.lat,
        lng: location.lng
      }
      this.marker = this.center
      this.zoom = 18
      this.model.gis_location = location.lng + ', ' + location.lat
    },
    mapClick(value) {
      this.marker.lat = value.latLng.lat()
      this.marker.lng = value.latLng.lng()
      this.model.gis_location = value.latLng.lng() + ', ' + value.latLng.lat()
    }
  }
}
</script>
